import React, { useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Toast } from '../ui';
import Header from './Header';
import ShareLink from './ShareLink';
import CreateNewButton from './CreateNewButton';
import { Eye, Plus } from 'lucide-react';

export default function ShareNote() {
  const { t } = useTranslation('shareNote');
  const { shortId } = useParams<{ shortId: string }>();
  const location = useLocation();
  const password = location.state?.password;
  const noteUrl = shortId ? `/note/${shortId}` : '';
  const [showToast, setShowToast] = useState(false);

  if (!shortId) {
    return (
      <div className="max-w-2xl mx-auto p-6 text-center">
        <div className="bg-white rounded-xl border p-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            {t('errors.notFound.title')}
          </h2>
          <p className="text-gray-600 mb-6">
            {t('errors.notFound.message')}
          </p>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            <Plus className="w-5 h-5 mr-2" />
            {t('actions.new')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <Header />
      
      <ShareLink 
        url={noteUrl} 
        password={password}
        onCopy={() => setShowToast(true)} 
      />

      <p className="text-sm text-gray-500 my-8">
        {t('warning')}
      </p>

      <div className="flex justify-center space-x-4">
        <Link
          to={`/note/${shortId}`}
          className="inline-flex items-center px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
        >
          <Eye className="w-5 h-5 mr-2" />
          {t('actions.view')}
        </Link>

        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          <Plus className="w-5 h-5 mr-2" />
          {t('actions.new')}
        </Link>
      </div>

      {showToast && (
        <Toast
          message={t('actions.copied')}
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
}